import { Capacitor } from "@capacitor/core";
import { Box, Button, makeStyles, Typography } from "@material-ui/core";
import * as React from "react";
import { useRecoilState } from "recoil";

import { StyledModal } from "@/components/StyledModal";
import { NeedShowUpdateModalState } from "@/view_models/atoms";

import theme from "./theme";

const useStyles = makeStyles(() => ({
  buttonContainer: {
    display: "flex",
    justifyContent: "center",
    borderTop: `1px solid ${theme.palette.semantic["border/strong"]}`,
    alignItems: "center",
    height: 60,
  },
  linkUpdate: {
    textDecoration: "none",
    cursor: "pointer",
    width: "100%",
    height: "100%",
    color: theme.palette.primary.main,
  },

  linkLater: {
    textDecoration: "none",
    cursor: "pointer",
    width: "100%",
    height: "100%",
    color: theme.palette.text.secondary,
  },

  messageContent: {
    padding: "24px 24px 0 24px",
    zIndex: 1300,
  },
  description: {
    textAlign: "center",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    zIndex: 1300,
  },
  divider: {
    height: "100%",
    backgroundColor: theme.palette.divider,
  },
}));

export const UpdateModal: React.FC = () => {
  const classes = useStyles();
  const [needShow] = useRecoilState(NeedShowUpdateModalState);
  if (!needShow) return null;

  const handleUpdate = () => {
    const platform = Capacitor.getPlatform();
    if (platform === "ios" || platform === "android") {
      window.open("https://propally.go.link/c7B2y", "_blank");
    } else {
      console.warn("Web版にはストアリンクは不要です");
    }
    // setNeedShowModal(false);
  };
  // const handleClose = () => {
  //   setNeedShowModal(false);
  // };

  return (
    <StyledModal>
      <Box className={classes.messageContent}>
        <Box textAlign="center" mb={2}>
          <Typography variant="h3">アップデートのご案内</Typography>
        </Box>
        <Typography className={classes.description}>
          新しいバージョンがリリースされました！
          <br />
          ストアよりアプリの更新をお願いします。
        </Typography>
      </Box>

      <Box className={classes.buttonContainer}>
        <Button className={classes.linkUpdate} onClick={handleUpdate}>
          更新する
        </Button>
      </Box>
    </StyledModal>
  );
};
